export const ACTION_TYPE = 'confirm';
export const ACTION_BUTTON_COLOR = 'green';
export const TITLE_KEY = 'are_you_sure';
export const LANG = 'en';
